import { useEffect } from 'react';

import type { RingPayload } from '@/redux/app/actions/calls';

export const TITLE_FLASH_MS = 1000;

export const ringTitle = (ring: RingPayload) => `Receiving Call: ${ring.contact_name || ring.contact_phone}`;

// While a ring prompt waits for an answer, flash the tab title so agents looking
// at another tab notice the call (the ringtone may be muted or autoplay-blocked)
export const useRingTitle = (ring: RingPayload | undefined) => {
  const title = ring ? ringTitle(ring) : null;

  useEffect(() => {
    if (!title) return undefined;

    let original = document.title;
    let showingRing = false;
    const flash = () => {
      // The page set its own title meanwhile (e.g. a Turbolinks navigation)
      if (document.title !== title && document.title !== original) original = document.title;
      showingRing = !showingRing;
      document.title = showingRing ? title : original;
    };
    flash();
    const interval = setInterval(flash, TITLE_FLASH_MS);
    return () => {
      clearInterval(interval);
      if (document.title === title) document.title = original;
    };
  }, [title]);
};
